import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  "data-section": "",
  class: "grid items-start gap-4 border-t border-gray-200 py-[26px] min-[900px]:grid-cols-[220px_minmax(0,1fr)] min-[900px]:gap-8"
}
const _hoisted_2 = {
  "data-section-title": "",
  class: "m-0 mb-1.5 text-base font-semibold text-gray-900"
}
const _hoisted_3 = {
  key: 0,
  "data-section-description": "",
  class: "m-0 text-sm leading-normal text-gray-600"
}
const _hoisted_4 = {
  key: 0,
  class: "flex min-w-0 flex-col gap-2.5"
}
const _hoisted_5 = {
  key: 1,
  class: "flex min-w-0 flex-col gap-4 rounded-[10px] border border-gray-200 bg-white px-[22px] py-5 shadow-[0_1px_2px_rgba(15,23,34,0.04),0_2px_8px_-4px_rgba(15,23,34,0.06)]"
}

import HighlightedText from '@/components/neue/wizard/HighlightedText'


export default {
  __name: 'WizardSection',
  props: {
  title: { type: String, required: true },
  description: { type: String, default: '' },
  plain: { type: Boolean, default: false }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      (__props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createVNode(_unref(HighlightedText), { text: __props.description }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.plain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ]))
}
}

}